import { FunctionComponent, useEffect, useState } from "react";
import styles from "./NavigationSideBar.module.css";

import MenuSideBarAtom, {
  MenuSideBarAtomType,
} from "../../../../src/atoms/menu/side";
import IconButton from "../../buttons/icon";
import {
  LabelPairedChevronLeftSmBoldIcon,
  LabelPairedChevronRightSmBoldIcon,
} from "@deriv/quill-icons";

export type NavigationSideBarType = {
  className?: string;
  onChange?: (item: MenuSideBarAtomType) => void;
  items: MenuSideBarAtomType[][];
  stickyItems: MenuSideBarAtomType[];
  type?: "expandable" | "fixed";
  selected?: MenuSideBarAtomType;
  expanded?: boolean;
};

export const NavigationSideBar: FunctionComponent<NavigationSideBarType> = ({
  className = "",
  onChange,
  items = [],
  stickyItems = [],
  type = "expandable",
  selected: externalSelected,
  expanded: externalExpanded = true,
}) => {
  const [selected, setSelected] = useState(externalSelected);
  const [expanded, setExpanded] = useState(externalExpanded);
  const [compress, setCompress] = useState(false);

  const handleExpand = () => {
    const timer = !expanded ? 0 : 500;
    setExpanded((prev) => !prev);
    setTimeout(() => {
      setCompress((prev) => !prev);
    }, timer);
  };

  const handleClick = (item: MenuSideBarAtomType) => {
    setSelected(item);
    onChange?.(item);
  };

  useEffect(() => {
    setSelected(externalSelected);
  }, [externalSelected]);

  return (
    <div
      className={[
        styles.root,
        "quill-ui-next-component",
        "quill-ui-next-no-select",
        className,
      ].join(" ")}
      data-type={type}
      data-is-expanded={expanded ? "yes" : "no"}
    >
      <div className={styles.menuContainer}>
        {items.map((group, groupIdx) => (
          <>
            <div className={styles.menuGroupContainer}>
              {group.map((item, idx) => (
                <MenuSideBarAtom
                  key={`${item.label ?? ""}-${idx}`}
                  label={compress && type === "expandable" ? "" : item?.label}
                  icon={item?.icon}
                  iconSelected={item?.iconSelected}
                  onClick={() => handleClick(item)}
                  isSelected={selected === item}
                  badgeLabel={item?.badgeLabel}
                  direction={type === "expandable" ? "row" : "column"}
                  expanded={type === "expandable" && !compress}
                />
              ))}
            </div>
            {groupIdx !== items.length - 1 && (
              <div className={styles.divider} />
            )}
          </>
        ))}
      </div>

      {type === "fixed" && stickyItems.length > 0 && (
        <div
          className={[styles.stickyContainer, styles.menuGroupContainer].join(" ")}
        >
          <div className={styles.divider} />
          {stickyItems.map((item, idx) => (
            <MenuSideBarAtom key={`${item.label ?? ""}-${idx}`} {...item} />
          ))}
        </div>
      )}

      {type === "expandable" && (
        <div
          className={`${styles.bottomContainer} ${
            !compress && styles.bottomContainerExpanded
          }`}
        >
          <IconButton
            icon={
              expanded ? (
                <LabelPairedChevronLeftSmBoldIcon />
              ) : (
                <LabelPairedChevronRightSmBoldIcon />
              )
            }
            color="blackWhite"
            style="tertiary"
            onClick={handleExpand}
          />
        </div>
      )}
    </div>
  );
};

NavigationSideBar.displayName = "NavigationSideBar";

export default NavigationSideBar;
